import React from "react";
import { useDroppable } from "@dnd-kit/core";
import { Badge, Empty, Typography } from "antd";

import { type SupportRequestStatus } from "@fitness-app/data-models";

import { STATUS_LABELS, type SupportRequestWithRelations } from "../supportConstants";
import { DraggableRequestCard } from "./DraggableRequestCard";

interface BoardColumnProps {
  status: SupportRequestStatus;
  requests: SupportRequestWithRelations[];
  unreadRequestIds: Set<string>;
  onCardClick: (request: SupportRequestWithRelations) => void;
}

export const BoardColumn: React.FC<BoardColumnProps> = ({ status, requests, unreadRequestIds, onCardClick }) => {
  const { setNodeRef, isOver } = useDroppable({
    id: status,
    data: { status },
  });

  return (
    <div
      ref={setNodeRef}
      className={`flex w-[290px] shrink-0 flex-col rounded-lg bg-gray-50 transition-colors ${
        isOver ? "bg-blue-50 ring-2 ring-blue-300" : ""
      }`}
    >
      <div className="flex items-center gap-2 px-3 py-2">
        <Typography.Text strong>{STATUS_LABELS[status]}</Typography.Text>
        <Badge count={requests.length} showZero color="#d9d9d9" />
      </div>

      <div className="flex min-h-[120px] flex-1 flex-col gap-2 overflow-y-auto p-2 pt-1">
        {requests.length === 0 && !isOver && (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Brak zgłoszeń" className="py-4" />
        )}

        {requests.length === 0 && isOver && (
          <div className="flex items-center justify-center rounded-md border-2 border-dashed border-blue-300 bg-blue-50 py-6 text-blue-500">
            Upuść tutaj
          </div>
        )}

        {requests.map((request) => (
          <DraggableRequestCard
            key={request.id}
            request={request}
            hasUnread={unreadRequestIds.has(request.id)}
            onClick={onCardClick}
          />
        ))}
      </div>
    </div>
  );
};
